import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import { Skeleton, Stack, Typography, useMediaQuery } from '@mui/material';
import StyledToggleButtonGroup from '../eir-mobile-offer-toggle/MobileOfferToggle.styled';
import styles from './styles';
import useLocalStorage, { getLocalStorage, hasValue } from '../../hooks/useLocalStorage';

const StandalonePortingToggle = ({
  storages,
  selected,
  loadingHandset,
  onPortingChange,
  setIsStandaloneHandset,
  handleClick,
  isStandaloneHandset,
}) => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const { setLocalStorage } = useLocalStorage();
  const [portingType, setPortingType] = useState('');
  const [toggleTitle, setToggleTitle] = useState('');
  const [stockIndex, setStockIndex] = useState();

  useEffect(() => {
    setStockIndex(storages.findIndex(res => res.value === selected.storage));
  });

  const handleKeepMyNumber = () => {
    setLocalStorage('STANDALONE_PORTIN', 'true');
    setToggleTitle('I want to keep my number');
    onPortingChange(true);
    setIsStandaloneHandset(true);
    handleClick();
  };
  const handleGetNewNumber = () => {
    setLocalStorage('STANDALONE_PORTIN', 'false');
    setToggleTitle('I want to get new number');
    onPortingChange(false);
    setIsStandaloneHandset(true);
    handleClick();
  };
  const handleChange = (event, portType) => {
    setPortingType(portType);
  };

  /* Check if it has porting value */
  useEffect(() => {
    if (getLocalStorage('STANDALONE_PORTIN')) {
      setIsStandaloneHandset(true);
    }
    if (hasValue('STANDALONE_PORTIN')) {
      setPortingType(getLocalStorage('STANDALONE_PORTIN') === 'true' ? 'keepNumber' : 'getNumber');
    }
  }, []);

  return !loadingHandset ? (
    <Stack sx={{ pb: sm ? '0px' : '20px' }}>
      <Typography variant='subtitle2' sx={styles(theme).colorTitle}>
        Switch to eir:
        <Typography variant='body2' sx={styles(theme).storageValue}>
          &nbsp; {toggleTitle}
        </Typography>
      </Typography>
      <Stack direction='row' sx={{ mb: sm && !isStandaloneHandset ? '80px' : '0px' }}>
        <StyledToggleButtonGroup
          size='small'
          onChange={handleChange}
          exclusive
          value={portingType}
          sx={styles(theme).toggleSelector}
          standaloneHandset
        >
          <ToggleButton
            sx={styles(theme).storageButton}
            height={40}
            value='keepNumber'
            onClick={handleKeepMyNumber}
            disabled={stockIndex !== undefined && storages[stockIndex]?.disable}
          >
            <Typography variant='body1' sx={styles(theme).portingValue}>
              Keep my number
            </Typography>
          </ToggleButton>

          <ToggleButton
            sx={styles(theme).storageButton}
            height={40}
            value='getNumber'
            onClick={handleGetNewNumber}
            disabled={stockIndex !== undefined && storages[stockIndex]?.disable}
          >
            <Typography variant='body1' sx={styles(theme).portingValue}>
              Get a new number
            </Typography>
          </ToggleButton>
        </StyledToggleButtonGroup>
      </Stack>
    </Stack>
  ) : (
    <Stack>
      <Skeleton variant='text' width='30%' />
      <Stack direction='row'>
        {Array(2)
          .fill()
          .map((_, i) => (
            <Skeleton key={i} sx={{ flex: 0.2, mr: 2 }} height={40} />
          ))}
      </Stack>
    </Stack>
  );
};

export default StandalonePortingToggle;
